/** The block-creator seeds a draft with `id: ''`; a missing id means nothing is being created or edited. */
export const isCreateMode = (entity?: { id?: string }) => entity?.id === '';
